<template>
  <v-dialog v-model="dialogDelete" max-width="500px" persistent>
    <v-card>
      <v-toolbar flat color="secondary">
        <v-toolbar-title class="text-white">
          {{ $t("labels.delete") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p class="text-h6 mt-4">
          {{ $t("strings.delete-model-question", isMultipleItem ? 2 : 1) }}
        </p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" variant="text" @click="closeDialog">
          {{ $t("labels.cancel") }}
        </v-btn>
        <v-btn
          color="secondary darken-1"
          variant="text"
          @click="deleteModelConfirm"
          :loading="loading"
          :disabled="loading"
        >
          {{ $t("labels.delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed, watch, ref } from "vue";

const props = defineProps({
  modelValue: Boolean,
  isMultipleItem: Boolean,
});

const emit = defineEmits(["update:modelValue", "confirm"]);
const loading = ref(false);

const dialogDelete = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});

watch(
  () => props.modelValue,
  (isOpen) => {
    if (isOpen) {
      loading.value = false;
    }
  },
);

function closeDialog() {
  dialogDelete.value = false;
  loading.value = false;
}

function deleteModelConfirm() {
  loading.value = true;
  emit("confirm");
}
</script>

<style scoped></style>
